import { IFormNewState } from './form-new.state';

export interface IApplicationState {
  formState?:IFormNewState
}
